<template>
  <div class="rename-module-wrapper">
    <transition name="el-fade-in-linear">
      <div
        v-if="visible"
        class="cover"
        @click="close"
      ></div>
    </transition>
    <transition name="scale">
      <div
        v-if="visible"
        class="message-container"
      >
        <div class="message-header">{{ title }}</div>
        <div class="message-content" style="margin-bottom: 22px">
          <div class="message-input-main">
            <EditorInput
              v-model="moduleTitle"
              placeholder="请输入模块名称"
              style="width: 100%"
              :maxlength="cvDetail.basic_info.lang === 'cn' ? 15 : 50"
              show-word-limit
              styleType="1"
            />
          </div>
        </div>
        <EditorLabelsPicker
          v-if="titles.length"
          v-model="moduleTitle"
          class="labels-list-container"
          :list="titles"
          singlePicker
        />
        <div class="message-btn">
          <button class="cancel" @click="close">取消</button>
          <button class="action" @click="confirm">保存</button>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapState} from 'vuex'
import EditorInput from '../EditorInput/EditorInput.vue';
import EditorLabelsPicker from '../EditorLabelsPicker/EditorLabelsPicker.vue';
export default {
  name: 'RenameModuleModal',
  components: {
    EditorInput,
    EditorLabelsPicker,
  },
  data() {
    return {
      visible: false,
      titles: [],
      moduleTitle: '',
      title: '修改模块名称',
    };
  },
  computed: {
    ...mapState('editor', ['cvDetail'])
  },
  methods: {
    clickLabelItem(item) {
      this.moduleTitle = item;
    },
    confirm() {
      this.$emit('confirm', this.moduleTitle);
    },
    close() {
      this.visible = false;
    },
    show(config = {}) {
      this.titles = config.titles || [];
      this.moduleTitle = config.moduleTitle || '';
      this.visible = true;
      this.title = config.title || '修改模块名称';
    },
  },
};
</script>
<style scoped lang="scss">
@import '../../styles/modal.scss';
.labels-list-container {
  :deep(.select-item) {
    border-radius: 6px;
  }
}
.message-input-main {
  :deep(.el-input__inner) {
    padding: 0 54px 0 15px;
  }
}
</style>
